import React, { useEffect, useState } from "react";
import { fetchFromStrapi } from "../api/strapi";
import { Link } from "react-router-dom";
import { BlogPageSkeleton, EmptyState } from "../components/SkeletonUI";


export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetchFromStrapi("/ecls");
        setBlogs(res?.data || []);
        console.log("Fetched blogs:", res?.data || []);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const getImageUrl = item =>
    item?.attributes?.image?.data?.attributes?.url;

  const featuredBlogs = blogs.slice(0, 2);
  const latestBlogs = blogs.slice(2, 5);

  const groupByCategory = category =>
    blogs.filter(
      b => b?.attributes?.serviceType === category
    );

  if (loading) return <BlogPageSkeleton />;

  if (!blogs.length) return (
    <EmptyState
      title="No posts yet"
      description="We're working on something great. Check back soon for the latest insights and updates."
      action={{ label: "Back to home", href: "/" }}
    />
  );

  return (
    <>
      {/* HERO */}
      <section className="text-white py-5 blog-hero-section">
        <div className="container">
          <h1 className="fw-bold display-5 mb-2 text-light">Blog</h1>
          <p className="text-light">
            News and insights on all things tech
          </p>

           {/* FEATURED */}
          <div className="py-5">
            <div className="row g-4">
              {featuredBlogs.map((item, index) => (
                <div
                  key={item.id}
                  className={index === 0 ? "col-md-8" : "col-md-4"}
                  style={{ height: 360 }}
                >

                  <Link
                    to={`/blog/${item.id}`}
                    className="text-decoration-none text-dark"
                  >
                    <div
                      className="position-relative rounded-4 overflow-hidden h-100"
                    >
                      <img
                        src={getImageUrl(item)}
                        alt=""
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                      />

                      <div
                        className="position-absolute bottom-0 start-0 w-100 p-4"
                        style={{
                          background:
                            "linear-gradient(transparent, rgba(0,0,0,0.8))",
                        }}
                      >
                        <small className="text-uppercase text-white-50">
                          {item.attributes.serviceType}
                        </small>
                        <h5 className="fw-semibold text-white mt-2">
                          {item.attributes.title}
                        </h5>
                        <small className="text-white-50">
                          {/* {item.attributes.publishedAt} */}
                          {new Date(item.attributes.publishedAt).toDateString()}
                        </small>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

     

      {/* LATEST */}
      <section className="container py-5">
        <h4 className="fw-bold mb-4">Latest</h4>
        <div className="row g-4">
          {latestBlogs.map(item => (
            <div key={item.id} className="col-md-4">
              <Link
                to={`/blog/${item.id}`}
                className="text-decoration-none text-dark"
              >
                <div className="card border-0 shadow-sm h-100">
                  <img
                    src={getImageUrl(item)}
                    alt=""
                    className="card-img-top"
                    style={{ height: 220, objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <small className="text-muted text-uppercase">
                      {item.attributes.serviceType}
                    </small>
                    <h6 className="fw-semibold mt-2">
                      {item.attributes.title}
                    </h6>
                    <small className="text-muted">
                      {new Date(item.attributes.publishedAt).toDateString()} 
                    </small>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* CATEGORY SECTIONS */}
      {[
        "RPA",
        "Web Development",
        "CSR",
      ].map(section => {
        const items = groupByCategory(section);

        if (!items.length) return null;

        return (
          <section
            key={section}
            className="py-5"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="container text-white">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold text-dark">{section}</h4>
                <span className="text-white-50">→</span>
              </div>

              <div className="d-flex gap-4 overflow-auto pb-2">
                {items.map(item => (
                  <div
                    key={item.id}
                    style={{ minWidth: 320 }}
                    className="bg-white text-dark rounded-4 overflow-hidden"
                  >
                    <Link
                      to={`/blog/${item.id}`}
                      className="text-decoration-none text-dark"
                    >
                      <img
                        src={getImageUrl(item)}
                        alt=""
                        style={{
                          height: 200,
                          width: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <div className="p-3">
                        <small className="text-muted text-uppercase">
                          {item.attributes.serviceType}
                        </small>
                        <h6 className="fw-semibold mt-2">
                          {item.attributes.title}
                        </h6>
                        <small className="text-muted">
                          {item.attributes.publishedAt}
                        </small>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
}
